// extracted by mini-css-extract-plugin
module.exports = {"upload":"UploadBtn_upload__3LdV_","btn":"UploadBtn_btn__wcuEv"};